import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../_models/funcionalidad';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { PaqueteSeguros } from '../../_models/paquete-seguros';
import { PaqueteSegurosService } from '../../_services/paquete-seguros.service';
import {Alerta} from '../../_models/alerta';
import {MatrizIdentidadService} from '../../_services/matriz-identidad.service';

@Component( {
  selector: 'app-matriz-identidad-listado',
  templateUrl: 'matriz-identidad-listado.component.html'
} )

export class MatrizIdentidadListadoComponent implements OnInit {

  listaMatrizIdentidad: any[] = [];
  carTabla = true;
  columnas: any[];
  busqueda: string;
  @ViewChild('dt', { static: true }) tabla: Table;
  menu: Funcionalidad = new Funcionalidad();
  mosDetalle = false;

  constructor( private matrizIdentidadService: MatrizIdentidadService,
               private navServicio: NavService,
               private router: Router,
               private autServicio: AutenticacionService ) {
  }

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/matriz-identidad' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'nombreCanal', header: this.navServicio.buscarMensaje( 'MATRIZIDENTIDAD.LBL_CANAL' ), sort: true },
      { field: 'nombreTipoCliente', header: this.navServicio.buscarMensaje( 'MATRIZIDENTIDAD.LBL_TIPOCLIENTE' ), sort: true },
      { field: 'nombreModoAutenticacion', header: this.navServicio.buscarMensaje( 'MATRIZIDENTIDAD.LBL_MODOAUTENTICACION' ), sort: true },
      { field: 'nombreModoAutenticacionOpcional', header: this.navServicio.buscarMensaje( 'MATRIZIDENTIDAD.LBL_MODOAUTENTICACIONOPCIONAL' ), sort: true },
      { field: 'indicadorValidacionIdentidad', header: this.navServicio.buscarMensaje( 'MATRIZIDENTIDAD.LBL_VALIDACIONIDENTIDAD' ), sort: true },
      { field: 'indicadorTomaDatos', header: this.navServicio.buscarMensaje( 'MATRIZIDENTIDAD.LBL_TOMADATOS' ), sort: true },
      { field: 'indicadorObligatorio', header: this.navServicio.buscarMensaje( 'MATRIZIDENTIDAD.LBL_INDICADOROBLIGATORIO' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.busqueda = this.navServicio.getSearch( 'matriz-identidad.component' );

    this.matrizIdentidadService.listado().subscribe( matIdentidad => {
      this.listaMatrizIdentidad = matIdentidad;
      this.carTabla = false;
      this.tabla.filterGlobal( this.busqueda, 'contains' );
    } );

  }

  crear() {
    this.router.navigate( [ 'apl/matriz-identidad/agregar' ] );
  }

  ver( palClave: any ) {
    this.router.navigate( [ 'apl/matriz-identidad/detalle/' + palClave.idMatrizIdentidad ] );
  }

  editar( palClave: any ) {
    this.router.navigate( [ 'apl/matriz-identidad/actualizar/' + palClave.idMatrizIdentidad ] )
  }

  setBusqueda() {
    this.navServicio.setSearch( 'matriz-identidad.component', this.busqueda );
  }

  cerrar() {
    this.mosDetalle = false;
  }
}
